import React from 'react';
import { Group, UnstyledButton, Text, Center, createStyles } from '@mantine/core';
import { ChevronDown, ChevronUp, Selector } from 'tabler-icons-react';

const useStyles = createStyles((theme) => ({
  th: {
    padding: '0 !important',
  },
  control: {
    width: '100%',
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,

    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    },
  },
  icon: {
    width: 21,
    height: 21,
    borderRadius: 21,
  },
}));

interface ThProps {
  children: React.ReactNode;
  reversed?: boolean;
  sorted?: boolean;
  onSort?: () => void;
  style?: React.CSSProperties;
  textAlign?: 'left' | 'right' | 'center' | 'justify' | undefined;
}

const Th = ({ children, reversed, sorted, onSort, style, textAlign }: ThProps) => {
  const { classes } = useStyles();
  const Icon = sorted ? (reversed ? ChevronUp : ChevronDown) : Selector;
  return (
    <th className={classes.th} style={style}>
      <UnstyledButton onClick={onSort} className={classes.control}>
        <Group position="apart" noWrap>
          <Text weight={500} size="sm" align={textAlign}>
            {children}
          </Text>
          {onSort && (
            <Center className={classes.icon}>
              <Icon size={14} />
            </Center>
          )}
        </Group>
      </UnstyledButton>
    </th>
  );
};

export default Th;
